<div class="card">
    <button
      mat-dialog-close
      title="Закрыть"
      class="close-button"
    >
       <mat-icon class="close-icon">close</mat-icon>
    </button>
    <div class="info-header">
        <h3 mat-headline-6>Техническая поддержка</h3>
    </div>
    <div class="info-content">
        <p [innerHTML]="'Связаться со службой<br/>'+
    'технической поддержки: <a href=\'mailto:fuv_online@rsmu.ru\'>fuv_online@rsmu.ru</a>'">
</p>

    </div>
</div>
